/* Volta theme — scripts */
(function () {
  'use strict';

  var settings = window.themeSettings || {};
  var routes = window.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', root_url: '/' };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || settings.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  window.VoltaMoney = formatMoney;

  /* ---------- Cart drawer ---------- */
  var drawer = function () { return document.getElementById('CartDrawer'); };
  var lastFocus = null;

  function openDrawer() {
    var d = drawer();
    if (!d) { window.location.href = routes.cart_url; return; }
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = d.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }
  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  function renderSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = html.querySelector('#CartDrawerInner');
      var current = document.querySelector('#CartDrawerInner');
      if (fresh && current) current.replaceWith(fresh);
    }
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });
  }

  function refreshCart() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return cart; });
  }

  function addToCart(body, button) {
    if (button) button.classList.add('is-loading');
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) { throw new Error(res.description); }
        renderSections(res.sections);
        return refreshCart();
      })
      .then(function () {
        if (settings.cartType === 'page') { window.location.href = routes.cart_url; return; }
        openDrawer();
      })
      .catch(function (err) {
        showError(button, err.message);
      })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  }

  function showError(anchor, message) {
    if (!anchor) { alertFallback(message); return; }
    var scope = anchor.closest('form') || anchor.parentElement;
    var box = scope.querySelector('[data-form-error]');
    if (!box) {
      box = document.createElement('p');
      box.className = 'form-message form-message--error';
      box.setAttribute('data-form-error', '');
      box.setAttribute('role', 'alert');
      scope.appendChild(box);
    }
    box.textContent = message;
    box.hidden = false;
  }
  function alertFallback(message) { console.warn(message); }

  function changeLine(line, quantity) {
    var d = document.querySelector('#CartDrawerInner');
    if (d) d.classList.add('is-updating');
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        renderSections(res.sections);
        updateCount(res.item_count);
      })
      .finally(function () {
        var n = document.querySelector('#CartDrawerInner');
        if (n) n.classList.remove('is-updating');
      });
  }

  /* ---------- Delegated events ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-product-form]')) {
      if (settings.cartType === 'page' && !form.hasAttribute('data-ajax-always')) return;
      e.preventDefault();
      var fd = new FormData(form);
      var item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
      var props = {};
      fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
      if (Object.keys(props).length) item.properties = props;
      var sp = fd.get('selling_plan'); if (sp) item.selling_plan = Number(sp);
      var err = form.querySelector('[data-form-error]'); if (err) err.hidden = true;
      addToCart({ items: [item] }, form.querySelector('[type=submit]'));
    }
    if (form.matches('[data-facets-form]')) {
      e.preventDefault();
      applyFacets(form);
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-cart-open]');
    if (opener && settings.cartType !== 'page' && drawer()) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }

    var qtyBtn = t.closest('[data-qty-btn]');
    if (qtyBtn) {
      var wrap = qtyBtn.closest('[data-qty]');
      var input = wrap.querySelector('input');
      var min = Number(input.min || 0);
      var step = Number(qtyBtn.getAttribute('data-qty-btn'));
      var next = Math.max(min, Number(input.value || 0) + step);
      if (input.max) next = Math.min(Number(input.max), next);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var remove = t.closest('[data-cart-remove]');
    if (remove && remove.closest('#CartDrawerInner')) {
      e.preventDefault();
      changeLine(Number(remove.getAttribute('data-cart-remove')), 0);
      return;
    }

    var thumb = t.closest('[data-media-thumb]');
    if (thumb) { showMedia(thumb.closest('[data-gallery]'), thumb.getAttribute('data-media-thumb')); return; }

    var copy = t.closest('[data-copy]');
    if (copy) {
      var code = copy.getAttribute('data-copy');
      if (navigator.clipboard) navigator.clipboard.writeText(code);
      var label = copy.querySelector('[data-copy-label]');
      if (label) { var old = label.textContent; label.textContent = 'Copied'; setTimeout(function () { label.textContent = old; }, 1600); }
      return;
    }

    var menuToggle = t.closest('[data-menu-toggle]');
    if (menuToggle) {
      var menu = document.getElementById('MenuDrawer');
      if (menu) {
        var open = menu.hasAttribute('open');
        if (open) { menu.removeAttribute('open'); document.body.style.overflow = ''; }
        else { menu.setAttribute('open', ''); document.body.style.overflow = 'hidden'; var c = menu.querySelector('[data-menu-toggle]'); if (c) c.focus(); }
      }
      return;
    }

    var facetsToggle = t.closest('[data-facets-toggle]');
    if (facetsToggle) {
      var panel = document.getElementById('Facets');
      if (panel) { var isOpen = panel.classList.toggle('is-open'); facetsToggle.setAttribute('aria-expanded', isOpen); }
      return;
    }

    var bundleAdd = t.closest('[data-bundle-add]');
    if (bundleAdd) {
      var bundle = bundleAdd.closest('[data-bundle]');
      var items = [];
      bundle.querySelectorAll('input[type=checkbox]:checked').forEach(function (cb) { items.push({ id: Number(cb.value), quantity: 1 }); });
      if (items.length) addToCart({ items: items }, bundleAdd);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = drawer();
      if (d && d.classList.contains('is-open')) closeDrawer();
      var menu = document.getElementById('MenuDrawer');
      if (menu && menu.hasAttribute('open')) { menu.removeAttribute('open'); document.body.style.overflow = ''; }
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-line-qty]') && t.closest('#CartDrawerInner')) {
      changeLine(Number(t.getAttribute('data-line-qty')), Number(t.value));
    }
    if (t.matches('[data-cart-page-qty]')) {
      var f = t.closest('form'); if (f) { f.classList.add('is-updating'); f.submit(); }
    }
    if (t.closest('[data-facets-form]') && !t.matches('[data-no-auto]')) {
      applyFacets(t.closest('[data-facets-form]'));
    }
    if (t.matches('[data-sort]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', t.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
    var bundle = t.closest('[data-bundle]');
    if (bundle) updateBundle(bundle);
  });

  /* ---------- Facets ---------- */
  function applyFacets(form) {
    var params = new URLSearchParams(new FormData(form));
    var clean = new URLSearchParams();
    params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
    var sort = new URLSearchParams(window.location.search).get('sort_by');
    if (sort) clean.set('sort_by', sort);
    window.location.href = window.location.pathname + '?' + clean.toString();
  }

  /* ---------- Gallery ---------- */
  function showMedia(gallery, id) {
    if (!gallery) return;
    gallery.querySelectorAll('[data-media-id]').forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(id));
    });
    gallery.querySelectorAll('[data-media-thumb]').forEach(function (b) {
      b.setAttribute('aria-current', b.getAttribute('data-media-thumb') === String(id) ? 'true' : 'false');
    });
  }

  /* ---------- Variant picker ---------- */
  function initVariantPicker(root) {
    var jsonEl = root.querySelector('[data-variants-json]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var idInputs = root.querySelectorAll('form input[name=id]');

    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-position]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function markAvailability(selected) {
      root.querySelectorAll('[data-option-position]').forEach(function (group) {
        var pos = Number(group.getAttribute('data-option-position'));
        group.querySelectorAll('input').forEach(function (input) {
          var available = variants.some(function (v) {
            if (!v.available) return false;
            for (var i = 0; i < selected.length; i++) {
              if (i === pos - 1) { if (v.options[i] !== input.value) return false; }
              else if (i < pos - 1 && v.options[i] !== selected[i]) return false;
            }
            return true;
          });
          input.classList.toggle('is-unavailable', !available);
        });
        var label = group.querySelector('[data-selected-value]');
        var c = group.querySelector('input:checked');
        if (label && c) label.textContent = c.value;
      });
    }

    function update() {
      var selected = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      markAvailability(selected);
      var btn = root.querySelector('[data-add-button]');
      var btnLabel = root.querySelector('[data-add-label]');
      if (!variant) {
        if (btn) btn.disabled = true;
        if (btnLabel) btnLabel.textContent = btnLabel.getAttribute('data-unavailable');
        return;
      }
      idInputs.forEach(function (input) { input.value = variant.id; input.dispatchEvent(new Event('change', { bubbles: true })); });
      if (btn) btn.disabled = !variant.available;
      if (btnLabel) btnLabel.textContent = variant.available ? btnLabel.getAttribute('data-add') : btnLabel.getAttribute('data-soldout');

      var priceEl = root.querySelector('[data-price]');
      if (priceEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceEl.classList.toggle('price--sale', !!onSale);
        var cur = priceEl.querySelector('[data-price-current]');
        var cmp = priceEl.querySelector('[data-price-compare]');
        var save = priceEl.querySelector('[data-price-save]');
        if (cur) cur.textContent = formatMoney(variant.price);
        if (cmp) { cmp.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; cmp.hidden = !onSale; }
        if (save) { save.hidden = !onSale; if (onSale) save.textContent = save.getAttribute('data-template').replace('[amount]', formatMoney(variant.compare_at_price - variant.price)); }
      }
      var badge = root.querySelector('[data-sale-badge]');
      if (badge) {
        var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        badge.hidden = !sale;
        if (sale) badge.textContent = '−' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
      }
      var sku = root.querySelector('[data-sku]');
      if (sku) sku.textContent = variant.sku || '';

      var stock = root.querySelector('[data-stock]');
      if (stock) {
        var threshold = Number(stock.getAttribute('data-threshold') || 20);
        var startStock = Number(stock.getAttribute('data-start') || 50);
        var qty = variant.inventory_quantity;
        var tracked = variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny';
        if (tracked && qty > 0 && qty <= threshold) {
          stock.hidden = false;
          var pct = Math.max(5, Math.min(98, Math.round((1 - qty / startStock) * 100)));
          stock.querySelector('[data-stock-text]').textContent = stock.getAttribute('data-template').replace('[count]', qty);
          stock.querySelector('[data-stock-fill]').style.width = pct + '%';
          var p = stock.querySelector('[data-stock-pct]'); if (p) p.textContent = pct + '% claimed';
        } else { stock.hidden = true; }
      }

      if (variant.featured_media) showMedia(root.querySelector('[data-gallery]'), variant.featured_media.id);
      if (root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-position]')) update(); });
    markAvailability(selectedOptions());
  }

  /* ---------- Countdown ---------- */
  function initCountdown(el) {
    var mode = el.getAttribute('data-mode');
    var endAttr = el.getAttribute('data-end');
    function target() {
      if (mode === 'daily') { var d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); }
      var t = Date.parse(endAttr);
      return isNaN(t) ? null : t;
    }
    var units = { d: el.querySelector('[data-unit=d]'), h: el.querySelector('[data-unit=h]'), m: el.querySelector('[data-unit=m]'), s: el.querySelector('[data-unit=s]') };
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var end = target();
      if (!end) return;
      var diff = Math.max(0, end - Date.now());
      var s = Math.floor(diff / 1000);
      var days = Math.floor(s / 86400);
      var hrs = Math.floor((s % 86400) / 3600);
      if (!units.d) hrs += days * 24;
      if (units.d) units.d.textContent = pad(days);
      if (units.h) units.h.textContent = pad(hrs);
      if (units.m) units.m.textContent = pad(Math.floor((s % 3600) / 60));
      if (units.s) units.s.textContent = pad(s % 60);
      el.setAttribute('aria-label', 'Ends in ' + (days ? days + ' days ' : '') + hrs + ' hours ' + Math.floor((s % 3600) / 60) + ' minutes');
      if (diff === 0) { el.classList.add('is-ended'); clearInterval(timer); }
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  /* ---------- Bundle ---------- */
  function updateBundle(bundle) {
    var total = 0, full = 0, count = 0;
    var discount = Number(bundle.getAttribute('data-discount') || 0);
    bundle.querySelectorAll('input[type=checkbox]').forEach(function (cb) {
      if (cb.checked) { total += Number(cb.getAttribute('data-price')); count++; }
    });
    full = total;
    if (count >= 2 && discount) total = Math.round(total * (100 - discount) / 100);
    var t = bundle.querySelector('[data-bundle-total]'); if (t) t.textContent = formatMoney(total);
    var f = bundle.querySelector('[data-bundle-full]'); if (f) { f.textContent = count >= 2 && discount ? formatMoney(full) : ''; }
    var c = bundle.querySelector('[data-bundle-count]'); if (c) c.textContent = count;
    var b = bundle.querySelector('[data-bundle-add]'); if (b) b.disabled = count === 0;
  }

  /* ---------- Recommendations ---------- */
  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var fresh = html.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) {
          el.innerHTML = fresh.innerHTML;
          el.hidden = false;
          var b = el.querySelector('[data-bundle]'); if (b) updateBundle(b);
        } else {
          el.remove();
        }
      })
      .catch(function () { el.remove(); });
  }

  /* ---------- Init ---------- */
  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-product-root]').forEach(initVariantPicker);
    scope.querySelectorAll('[data-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-recommendations-loader]').forEach(initRecommendations);
    scope.querySelectorAll('[data-bundle]').forEach(updateBundle);
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
